var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Soll der User wirklich gelöscht werden?","action":"delete","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('user-form',{attrs:{"user":_vm.user,"company-id":_vm.companyId,"disabled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }